// extracted by mini-css-extract-plugin
export default {"content":"Announcements_content__IhEci","content2":"Announcements_content2__QeS49","content3":"Announcements_content3__SihZ5","link":"Announcements_link__m0rWV"};